"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _NotificationCenter = _interopRequireDefault(require("./NotificationCenter"));
var _utils = require("../utils");
var _MessageContent = _interopRequireDefault(require("./MessageContent"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultDuration = 3000;
var defaultTop = 16;
var messageInstance;
var key = 1;
var getContainer;
var maxCount;
function getInstance(callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }
  _NotificationCenter.default.newInstance({
    type: 'message',
    style: {
      top: defaultTop
    },
    // 覆盖原来的样式
    getContainer: getContainer,
    maxCount: maxCount
  }, function (instance) {
    if (messageInstance) {
      callback(messageInstance);
      return;
    }
    messageInstance = instance;
    callback(instance);
  });
}
function open(config) {
  var message = config.message,
    d = config.duration,
    type = config.type,
    onClose = config.onClose,
    icon = config.icon,
    closable = config.closable,
    k = config.key,
    className = config.className,
    style = config.style,
    colorful = config.colorful;
  var duration = d !== undefined ? d : defaultDuration;
  key += 1;
  var targetKey = k || key;
  var handleClose = function handleClose() {
    if (messageInstance) {
      messageInstance.remove(targetKey);
    }
    if ((0, _utils.isFunction)(onClose)) {
      onClose();
    }
  };
  var notice = {
    key: targetKey,
    duration: duration,
    closable: closable,
    className: className,
    style: style,
    content: function content(remainingTime) {
      return /*#__PURE__*/_react.default.createElement(_MessageContent.default, {
        type: type,
        icon: icon,
        closable: closable,
        colorful: colorful,
        remainingTime: remainingTime,
        onClose: handleClose
      }, message);
    },
    onClose: handleClose
  };
  getInstance(function (instance) {
    instance.add(notice);
  });
  return {
    update: function update(newConfig) {
      if (messageInstance) {
        open(_objectSpread(_objectSpread(_objectSpread({}, config), newConfig), {}, {
          key: targetKey
        }));
      }
    },
    close: handleClose
  };
}
function closeAll() {
  if (messageInstance) {
    messageInstance.destroy();
    messageInstance = null;
  }
}
var api = {
  open: open,
  config: function config(options) {
    closeAll();
    if (options.top !== undefined) {
      defaultTop = options.top;
      messageInstance = null;
    }
    if (options.duration !== undefined) {
      defaultDuration = options.duration;
    }
    if (options.getContainer !== undefined) {
      getContainer = options.getContainer;
      messageInstance = null;
    }
    if (options.maxCount !== undefined) {
      maxCount = options.maxCount;
      messageInstance = null;
    }
  },
  closeAll: closeAll,
  success: function success(options) {
    return api.open(_objectSpread(_objectSpread({}, options), {}, {
      type: 'success'
    }));
  },
  info: function info(options) {
    return api.open(_objectSpread(_objectSpread({}, options), {}, {
      type: 'info'
    }));
  },
  warning: function warning(options) {
    return api.open(_objectSpread(_objectSpread({}, options), {}, {
      type: 'warning'
    }));
  },
  error: function error(options) {
    return api.open(_objectSpread(_objectSpread({}, options), {}, {
      type: 'error'
    }));
  },
  loading: function loading(options) {
    return api.open(_objectSpread(_objectSpread({}, options), {}, {
      type: 'loading'
    }));
  }
};
var _default = exports.default = api;